const projectedWinners = {
  en: {
    projectedWinnersPage: {
      title: "Projected Winners",
      subtitle: "Real-time projected election winners by region",
      electionTypePlaceholder: "Election Type",
      types: {
        presidential: "Presidential",
        parliamentary: "Parliamentary",
        regional: "Regional",
        council: "Council"
      },
      refresh: "Refresh",
      lastUpdated: "Last updated: {{time}}",
      noResultsYet: "No Results Yet",
      noResultsHint: "National projected winner will appear when results are submitted",
      nationalBadge: "NATIONAL PROJECTED WINNER",
      votes: "votes",
      votesLabel: "Votes",
      noRegional: "No regional results available yet",
      unknown: "Unknown",
      regionalOverview: "Regional Winners Overview",
      regionsReporting_one: "{{count}} region reporting",
      regionsReporting_other: "{{count}} regions reporting",
      votesTooltip: "{{count}} votes",
      winnerTooltip: "Winner: {{name}}",
      nationalLevel: "National Level",
      regionalLevel: "Regional Level",
      regionsReportingStat: "Regions Reporting",
      totalRegions: "Total Regions",
      leadingVotes: "Leading Votes",
      regionalWinners: "Regional Winners",
      disclaimer: "These are projected winners based on currently submitted results. Final results are subject to official verification by ELECAM."
    }
  },
  fr: {
    projectedWinnersPage: {
      title: "Vainqueurs projetés",
      subtitle: "Vainqueurs projetés des élections par région, en temps réel",
      electionTypePlaceholder: "Type d'élection",
      types: {
        presidential: "Présidentielle",
        parliamentary: "Législative",
        regional: "Régionale",
        council: "Municipale"
      },
      refresh: "Actualiser",
      lastUpdated: "Dernière mise à jour : {{time}}",
      noResultsYet: "Aucun résultat pour le moment",
      noResultsHint: "Le vainqueur national projeté apparaîtra dès que des résultats seront soumis",
      nationalBadge: "VAINQUEUR NATIONAL PROJETÉ",
      votes: "voix",
      votesLabel: "Voix",
      noRegional: "Aucun résultat régional disponible pour le moment",
      unknown: "Inconnu",
      regionalOverview: "Aperçu des vainqueurs régionaux",
      regionsReporting_one: "{{count}} région ayant transmis ses résultats",
      regionsReporting_other: "{{count}} régions ayant transmis leurs résultats",
      votesTooltip: "{{count}} voix",
      winnerTooltip: "Vainqueur : {{name}}",
      nationalLevel: "Niveau national",
      regionalLevel: "Niveau régional",
      regionsReportingStat: "Régions ayant transmis",
      totalRegions: "Total des régions",
      leadingVotes: "Voix du leader",
      regionalWinners: "Vainqueurs régionaux",
      disclaimer: "Il s'agit de vainqueurs projetés sur la base des résultats actuellement soumis. Les résultats définitifs sont soumis à la vérification officielle d'ELECAM."
    }
  }
};

export default projectedWinners;
